

const inshF = {
  dia:{fav:false,curr:false,invs:false},
  
}

 export {inshF}